import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M2 21h19v-3H2v3zM20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zM2 3v3h19V3H2z"
}), 'ViewDay');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ViewDay.js
// module id = 7095
// module chunks = 2